import React from "react";
import OriginListPageContainer from "./OriginListPageContainer";

export class OriginListPage extends React.Component {
  render() {
    return <OriginListPageContainer {...this.props} />;
  }
}
